import React from 'react';
import { useSelector } from 'react-redux';



const Carousel = () => {
    const carusel = useSelector(state => state.carusel)
    

    return (
        <div id="cars-carousel" className="carousel slide" data-ride="carousel" data-pause="hover">
            <div className="carousel-inner">
                <ol className="carousel-indicators">
                    {carusel.map((vehicle, index) => <li key={"slide" + vehicle.Id} data-target="#cars-carousel" data-slide-to={index} className={`${(index === 0 && "active")}`}></li>)}
                </ol>
                {
                    carusel.map((vehicle, index) =>
                        <div key={vehicle.Id} className={`carousel-item ${(index === 0 && `active`)}`}>
                            <img src={(vehicle.EsLocal === "Y") ? `${process.env.PUBLIC_URL}/images/${vehicle.URL}` : vehicle.URL} className="d-block w-100 h-100" alt="..." />
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default Carousel
